import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EulaModal from './EulaModal';
import AboutModal from './AboutModal';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Header = React.memo(({ isExpanded, setIsExpanded }) => {
  const [showEula, setShowEula] = useState(false);
  const { logout, user, revokeAllTrustedDevices } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showAbout, setShowAbout] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      navigate('/login');
    }
  };

  const isActiveRoute = (path) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname === path;
  };

  const handleShowEula = () => {
    setShowEula(true);
  };

  const handleHideEula = () => {
    setShowEula(false);
  };

  const handleShowAbout = () => {
    setShowAbout(true);
  };

  const handleHideAbout = () => {
    setShowAbout(false);
  };

  const handleRevokeAllTrustedDevices = async () => {
    if (!window.confirm('Revoke ALL trusted devices? You will need 2FA on all devices for next login.')) {
      return;
    }

    try {
      await revokeAllTrustedDevices();
      alert('All trusted devices revoked. 2FA required on all devices for next login.');
    } catch (error) {
      console.error('Failed to revoke trusted devices:', error);
      alert('Failed to revoke devices.');
    }
  };

  return (
    <>
      <div className={`sidebar ${isExpanded ? 'expanded' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-title">
            <img src="/favicon2.png" alt="Skill & Reach Logo" className="logo-icon" />
            <span className="title-text">OSIRIS</span>
          </div>
          <button 
            className="sidebar-toggle"
            onClick={() => setIsExpanded(!isExpanded)}
            title={isExpanded ? "Collapse" : "Expand"}
          >
            <i className={`fa-solid fa-thumbtack${isExpanded ? '-slash' : ''}`}></i>
          </button>
        </div>

        <nav className="sidebar-nav">
          <Link 
            to="/dashboard" 
            className={`sidebar-link ${isActiveRoute('/') ? 'active' : ''}`}
            title="Dashboard"
          >
            <i className="fas fa-home"></i>
            <span className="link-text">Dashboard</span>
          </Link>
          
          <Link 
            to="/domains" 
            className={`sidebar-link ${isActiveRoute('/domains') ? 'active' : ''}`}
            title="Domains"
          >
            <i className="fas fa-globe"></i>
            <span className="link-text">Domains</span>
          </Link>
          
          <Link 
            to="/tags" 
            className={`sidebar-link ${isActiveRoute('/tags') ? 'active' : ''}`}
            title="Tags"
          >
            <i className="fas fa-tags"></i>
            <span className="link-text">Tags</span>
          </Link>
          
          <Link 
            to="/account" 
            className={`sidebar-link ${isActiveRoute('/account') ? 'active' : ''}`}
            title="Account"
          >
            <i className="fas fa-user"></i>
            <span className="link-text">Account</span>
          </Link>
          {user && user['user_type'] === 2 && (
            <Link
              to="/admin"
              className={`sidebar-link ${isActiveRoute('/admin') ? 'active' : ''}`}
              title="Admin"
            >
              <i className="fas fa-user-shield"></i>
              <span className="link-text">Admin</span>
            </Link>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="footer-links">
            <button
              className="footer-link"
              onClick={handleShowAbout}
              title="About"
            >
              <i className="fas fa-info-circle"></i>
              <span className="link-text">About</span>
            </button>

            <button 
              className="footer-link"
              onClick={handleShowEula}
              title="End User License Agreement"
            >
              <i className="fas fa-file-contract"></i>
              <span className="link-text">EULA</span>
            </button>
            
            <button 
              className="footer-link trusted-device-btn"
              onClick={handleRevokeAllTrustedDevices}
              title="Revoke ALL trusted devices (2FA required on all devices for next login)"
            >
              <i className="fas fa-shield-alt"></i>
              <span className="link-text">Forget Devices</span>
            </button>
            
            <button 
              className="footer-link logout-btn"
              onClick={handleLogout}
              title="Logout"
            >
              <i className="fas fa-sign-out-alt"></i>
              <span className="link-text">Logout</span>
            </button>
          </div>
          
          <div className="footer-copyright">
            <span className="copyright-text">© {new Date().getFullYear()} Skill & Reach</span>
          </div>
        </div>
      </div>

      <EulaModal isOpen={showEula} onClose={handleHideEula} />
      <AboutModal isOpen={showAbout} onClose={handleHideAbout} />
    </>
  );
});

export default Header; 